import React, { Component } from "react"
import { RouteComponentProps } from 'react-router-dom'
import AuthService from "./AuthService"
import { AppState } from "../AppState"
import { Action, Dispatch } from "redux"
import { connect } from 'react-redux'
import { ssoOrderRequest } from "../actions/WorkforceOneLoginActions"
import { GetSSOPayload, SetEmbeddedOrderMode, SetSiteSearchMode } from "../storage/AuthToken"
import PageLoading from "../components/PageLoading"
import FormatData from "../formatters/FormatBase64"

export interface SSOCallbackState {
  spinnerMessage: string
}
export interface SSOCallbackAppStateProps { }
export interface SSOCallbackDispatchProps {
  login: (ssoToken: string, data?: string) => void
}

export class SSOCallback extends Component<SSOCallbackAppStateProps & SSOCallbackDispatchProps & RouteComponentProps, SSOCallbackState>{
  state: SSOCallbackState = { spinnerMessage: "Logging in..." }

  componentDidMount() {
    const data = GetSSOPayload()
    const payload = parsePayload(data)
    if (payload && (payload as { Target: string }).Target === 'site-search') {
      SetSiteSearchMode()
    }
    if (payload && (payload as { Target: string }).Target === 'order') {
      SetEmbeddedOrderMode()
    }
    const authService = new AuthService()
    authService.signinRedirectCallback(this.props.location.pathname?.replace("/access_token=", "/&access_token=")).then((user) => {
      if (user) {
        this.props.login(user.access_token, data)
      }
    }).catch(() => {
      this.setState({ spinnerMessage: "Logging in error..." })
    })
  }

  render() { return <>
    <PageLoading message={this.state.spinnerMessage} showNav={true} embedingMode={true}/>
  </>
  }
}

function parsePayload(base64String: string): object | undefined {
  try {
    const bytes = FormatData(base64String)
    const str = new TextDecoder().decode(bytes)
    return JSON.parse(str)
  } catch (error) {
    return undefined
  }
}

function mapStateToProps(state: AppState): SSOCallbackAppStateProps {
  return {
  }
}

function mapDispatchProps(dispatch: Dispatch<Action>): SSOCallbackDispatchProps {
  return {
    login: (ssoToken: string, data?: string) => (dispatch(ssoOrderRequest(ssoToken, data)))
  }
}

export default connect<SSOCallbackAppStateProps, SSOCallbackDispatchProps, {}, AppState>(
  mapStateToProps, mapDispatchProps)(SSOCallback)
